export const getHomePageLink = (userLevelId, companyId) => {
  if (userLevelId === 1) {
    return '/pinsadmin';
  }

  return `/companies/${companyId}/departments`;
};
